import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDeviceBreakpoint } from "@/partner/shared/hooks";
import { StyledDrawer } from "@/partner/shared/ui";

export interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
  logo?: ReactNode;
  userCard?: ReactNode;
  menu?: ReactNode;
  onSignOut: () => void;
  signOutLoading: boolean;
}

export const Sidebar: FC<SidebarProps> = ({
  isOpen,
  onClose,
  logo,
  userCard,
  menu,
  onSignOut,
  signOutLoading,
}) => {
  const isLg = useDeviceBreakpoint("lg");
  const { t } = useTranslation();

  return (
    <StyledDrawer
      anchor="left"
      open={isOpen || !isLg}
      onClose={onClose}
      variant={isLg ? "temporary" : "persistent"}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: 0,
        }}
      >
        <Box sx={{ flexShrink: 0 }}>
          {logo}
          {/* <Divider sx={{ mx: 3 }} /> */}
          {userCard}
          {/* <Divider sx={{ mx: 3 }} /> */}
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "auto",
          }}
        >
          {menu}
        </Box>

        <List disablePadding sx={{ flexShrink: 0 }}>
          <ListItem disablePadding>
            <ListItemButton
              sx={{ py: 3 }}
              disabled={signOutLoading}
              onClick={onSignOut}
            >
              <ListItemIcon sx={{ minWidth: "32px" }}>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary={t("menu.signOut")} />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </StyledDrawer>
  );
};
